<template>
	<div>
		<v-row>
			<v-col>
				<h3>
					<v-icon
						start
						icon="$pages"
					/>
					<strong>
						<translate>Pages</translate>
					</strong>
				</h3>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-card>
					<v-card-title>
						<translate>Content Pages Tree</translate>
					</v-card-title>
					<v-card-text>
						<v-row
							v-for="(groupedPage, groupName) in groupedPages"
							:key="groupedPage"
						>
							<v-col>
								<v-row>
									<v-col>
										<translate>{{ groupName.toUpperCase() }}</translate>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-expansion-panels
											multiple
										>
											<pages-overview-expansion-panel :grouped-page="groupedPage" />
										</v-expansion-panels>
									</v-col>
									<v-col v-if="groupedPage.length === 0">
										<translate>No pages found</translate>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<pages-overview-info-card />
			</v-col>
		</v-row>
	</div>
</template>

<script>

import PagesOverviewInfoCard from './PagesOverviewInfoCard.vue';
import {
	axios,
} from '../../../../services/axios-service';
import PagesOverviewExpansionPanel from './PagesOverviewExpansionPanel.vue';

export default {
	name: 'PagesOverview',
	components: {
		PagesOverviewExpansionPanel,
		PagesOverviewInfoCard
	},

	data () {
		return {
			groupedPages: []
		};
	},

	mounted () {
		this.getPages();
	},

	methods: {
		/**
		 * retrieve pages
		 */
		getPages () {
			axios.get('/api/v0/pages/contentpagestree')
				.then(({
					data,
				}) => {
					this.groupedPages = data;
				})
				.catch((error) => {
					window.captureException(error);
				});
		}
	}
};
</script>
